module.exports = __webpack_public_path__ + "static/media/icn-care.d906ef12.svg";